<template>
    <div>
        <h1>Kohlenhydrate</h1>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/fischer-projektion.png"
            alt="Fischer Projektion der Kohlenhydrate"
            title="Fischer Projektion der Kohlenhydrate"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="HAWORTH-Projektion"></chapter-heading>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/haworth-projektion.png"
            alt="HAWORTH Projektion der Kohlenhydrate"
            title="HAWORTH Projektion der Kohlenhydrate"
            width="500px"
            height="auto"
        />
        <p>
            Eselsbrücke: 
            Floh – Regel
            Fischer links – Haworth oben
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="3 Beispiele für Monosaccharide"></chapter-heading>
        <p>
            1. Glucose, 2. Fructose, 3. Galactose
        </p>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/glucose.png"
            alt="Glucose"
            title="Glucose"
            width="200px"
            height="auto"
        />
        <img
            src="@/assets/img/stoffe/kohlenhydrate/fructose.jpg"
            alt="Fructose"
            title="Fructose"
            width="200px"
            height="auto"
        />
        <img
            src="@/assets/img/stoffe/kohlenhydrate/galactose.png"
            alt="Galactose"
            title="Galactose"
            width="200px"
            height="auto"
        />
        <p>
            Eselsbrücke: für Glucose
            Ta-Tü-Ta-Ta
        </p>
        <p>
            Eselsbrücke: für Fructose
            Tü-Ta-Ta
        </p>
        <hr class="chapter-split" />
        <chapter-heading title="Glykosidische Bindung"></chapter-heading>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/glykosidische-bindung.png"
            alt="Glykosidische Bindung"
            title="Glykosidische Bindung"
            width="400px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Disaccharide"></chapter-heading>
        <p>Saccharose</p>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/saccharose.png"
            alt="Saccharose"
            title="Saccharose"
            width="400px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Maltose (Malzzucker) aus 2 Glucosemolekülen"></chapter-heading>
        <p>Maltose</p>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/maltose.png"
            alt="Maltose"
            title="Maltose"
            width="400px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Lactose (Milchzucker) aus 2 Glucosemolekülen aus β-D-Galactose und D-Glucose"></chapter-heading>
        <p>Maltose</p>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/lactose.png"
            alt="Lactose"
            title="Lactose"
            width="400px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Cellulose"></chapter-heading>
        <p>Maltose</p>
        <img
            src="@/assets/img/stoffe/kohlenhydrate/cellulose.png"
            alt="Cellulose"
            title="Cellulose"
            width="500px"
            height="auto"
        />
        
    </div>
</template>

<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
